import { createSelector } from '@ngrx/store';

import { AppStore } from '../models/shared.model';
import { FEATURE_STORE_NAME, ISharedStore } from './shared.state';

/**
 * Feature app store
 */
export interface IFeatureAppStore extends AppStore {
	/**
	 * Feature store name
	 */
	[FEATURE_STORE_NAME]: ISharedStore;
}

/**
 * Shared store selector
 *
 * @param state feature app store
 * @returns state
 */
export const SELECT_SHARE_STORE = (state: IFeatureAppStore): any => state[FEATURE_STORE_NAME];

/**
 * Step selector
 */
export const SELECT_STEP = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.step);

/**
 * Navigation selector
 */
export const SELECT_NAVIGATION = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.navigation);

/**
 * Steps selector
 */
export const SELECT_STEPS = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.steps);

/**
 * Request id selector
 */
export const SELECT_REQUEST_ID = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state.savedRequestId);

/**
 * Form responses selector
 */
export const SELECT_FORM_RESPONSES = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.formResponses);

/**
 * Expedient selector
 */
export const SELECT_EXPEDIENT = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.expedient);

/**
 * Form version selector
 */
export const SELECT_FORM_VERSION = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.expedient?.versionFormulario);

/**
 * First name from responses selector
 */
export const SELECT_FIRST_NAME_FORM_RESPONSES = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.formResponses?.['PI01']);
export const SELECT_EMAIL_FORM_RESPONSES = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.formResponses?.['PI11']);
export const SELECT_DNI_FORM_RESPONSES = createSelector(SELECT_SHARE_STORE, (state: ISharedStore): any => state?.formResponses?.['PI06']);
